export enum RadioBooleanFilterOperation {
  IS_TRUE = 'IS_TRUE',
  IS_FALSE = 'IS_FALSE',
  IS_UNKNOWN = 'IS_UNKNOWN',
  HAS_ANY_VALUE = 'HAS_ANY_VALUE',
}

export type RadioBooleanFilterValue = {
  operation: RadioBooleanFilterOperation;
};

export type RadioBooleanFilterValueType = RadioBooleanFilterValue | undefined;
